import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, ButtonToolbar, Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { RemoveProductFromCart } from '../queries/cart'
import { withApollo, Mutation } from 'react-apollo';

class ModalComponent extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    color: PropTypes.string.isRequired,
    colored: PropTypes.bool,
    header: PropTypes.bool
  };

  constructor(props) {
    super(props);
    // this.state = {
    //   modal: false
    // };

    this.toggle = this.props.toggle;
  }

  // toggle() {
  //   this.setState({
  //     modal: !this.state.modal
  //   });
  // }

  // removeFromCart() {
  //   {data: removedData} = this.props.client.mutation
  // }

  render() {
    //console.log(this.props.ct)
    let Icon;
    const { ComingSoon, DropZone, Collapse, Msg } = this.props;

    switch (this.props.color) {
      case 'primary':
        Icon = <span className='lnr lnr-pushpin modal__title-icon' />;
        break;
      case 'success':
        Icon = <span className='lnr lnr-thumbs-up modal__title-icon' />;
        break;
      case 'warning':
        Icon = <span className='lnr lnr-flag modal__title-icon' />;
        break;
      case 'danger':
        Icon = <span className='lnr lnr-cross-circle modal__title-icon' />;
        break;
      default:
        break;
    }

    return (
      <div>
        {this.props.children}
        <Modal isOpen={this.props.modal}
          className={`modal-dialog--${this.props.color} ${this.props.colored ?
            'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''} 
            ${this.props.className}`}>
          <div className='modal__header'>
            <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle} />

            {this.props.title ? <h2 className='bold-text  modal__title'>{this.props.title}</h2> : null}
          </div>
          <div className='modal__body'>
            {ComingSoon ? <ComingSoon /> : null}
            {Collapse ? <Collapse /> : DropZone ? <DropZone /> : null}
            {Msg ? <p><span>{Icon}</span> {this.props.Msg}</p> : null}
          </div>
          {this.props.showButtonBar ? <ButtonToolbar className='modal__footer'>
            <Button onClick={this.toggle}>Cancel</Button>{' '}
            <Mutation mutation={RemoveProductFromCart}
              onCompleted={() => {
              }}>
              {(removeProductFromCart) => (
                <Button outline={this.props.colored} color={this.props.color} onClick={() => {
                  this.props.confirmDelete(this.props.ct.productID ?
                    this.props.ct.productID :
                    this.props.ct.productName, this.props.ct.price, this.props.ct.quantity)
                  this.toggle();
                  removeProductFromCart({
                    variables: {
                      productId: this.props.ct.productID
                    }
                  })
                }}>I'm Sure</Button>
              )}
            </Mutation>
          </ButtonToolbar> : null}
        </Modal>
      </div>
    );
  }
}
export default withRouter(withApollo(ModalComponent))


// WEBPACK FOOTER //
// ./src/components/Modal.js